/* eslint-disable max-params */
import map from "lodash/fp/map";
import isUndefined from "lodash/fp/isUndefined";
import assign from "lodash/fp/assign";
import isNil from "lodash/fp/isNil";
import concat from "lodash/fp/concat";
import dialogCtrl from "./dialog/dialog.controller";
import dialogTmpl from "./dialog/dialog.html";
import dispatchDialogCtrl from "./dispatchDialog/dispatchDialog.controller";
import dispatchDialogTmpl from "./dispatchDialog/dispatchDialog.html";

import conflictingDialogCtrl from "../../components/conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../../components/conflictingDialog/conflictingDialog.html";

import constants from "../../core/constants";
import moment from "moment";
import { formatTwentyFourHourTimeFilter } from "../../core/utils";
import polyline from "google-polyline";
class Controller {
  constructor($injector, $stateParams) {
    "ngInject";

    this.Ride = $injector.get("Ride");
    this.Route = $injector.get("Route");
    this.Events = $injector.get("Events");
    this.Bustype = $injector.get("Bustype");
    this.Schedule = $injector.get("Schedule");
    this.Messages = $injector.get("Messages");
    this.$mdDialog = $injector.get("$mdDialog");
    this.$stateParams = $injector.get("$stateParams");
    this.RouteTransforms = $injector.get("RouteTransforms");
    this.RidesTransforms = $injector.get("RidesTransforms");
    this.Sections = $injector.get("Sections");
    this.ActionLists = $injector.get("ActionLists");
    this.Lists = $injector.get("Lists");
    this.Reservation = $injector.get("Reservation");
    this.Contracts = $injector.get("Contracts");
    this.ReservationTransforms = $injector.get("ReservationTransforms");
    this.routesSections = this.Sections.routesSections;
    this.ridesFields = this.RidesTransforms.fields;
    this.ridesFilters = this.RidesTransforms.filters;
    this.scheduleLabelsWithNone = this.Lists.all.scheduleLabelsWithNone;
    this.activeFilter = this.Lists.all.active;
    this.onUpdateRoute = this.Events.getUpdateEvent("route");
    this.routeStationEvent = this.Events.getUpdateEvent("routeStation");
    this.onReservationUpdateEvent = this.Events.getUpdateEvent("reservation");
    this.reflectRouteEvent = this.Events.getUpdateEvent("reflectRouteSchedule");
    this.deleteScheduleEvent = this.Events.getDeleteEvent("scheduleDelete");
    this.onAddScheduleErrorEvent = this.Events.getErrorEvent("scheduleAdd");
    this.newScheduleItem = assign({}, this.RouteTransforms.newScheduleItem);
    this.rideResourceActions = this.ActionLists.all.rideActions;
    this.enableEdit = true;
    this.$stateParams = $stateParams;
    this.schedulesPage = this.$stateParams.page || constants.defaultPage;
    this.schedulesLimit = this.$stateParams.limit || constants.defaultLimit;
    this.notDispatchedParams = {
      route: $stateParams.id,
      is_dispatched: false,
      isCityRequired: false,
    };
    this.timeFilter = formatTwentyFourHourTimeFilter();
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const getIdList = (item) => item._id;

    const formatSchedules = (schedule) => {
      const options = {};
      options.time = moment(schedule.time.value).format(constants.timeFormat);
      options.params = {
        route: this.$stateParams.id,
        schedule_id: schedule._id.value,
        isCityRequired: false,
      };

      return options;
    };

    this.showConflictDialog = (captainConflict) => {
      const timezone = this.route.city.timezone;
      this.$mdDialog.show({
        controller: conflictingDialogCtrl,
        controllerAs: "$ctrl",
        template: conflictingDialog,
        locals: {
          captainConflict,
          timezone,
        },
      });
    };
    const getAllSchedules = () => {
      this.Schedule.getAll({
        route: this.$stateParams.id,
        limit: this.schedulesLimit,
        isCityRequired: false,
        page: 1,
      }).$promise.then((response) => {
        this.schedules = this.RouteTransforms.justifySchedule(
          response.hits,
          this.routeTimezone
        );
        this.populateReservation();
        this.schedulesTotal = response.total;
        this.hasPaging = this.schedulesTotal > this.schedules.length;
        this.formatedSchedules = map(formatSchedules)(this.schedules);
      });
    };
    const onStationEdit = (options) => {
      const stations = map(getIdList)(options.stations);
      this.Route.updateAction(this.$stateParams.id, "update_stations", {
        stations,
      }).$promise.then(
        () => {
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("stations")
          );
          getAllSchedules();
        },
        (response) => {
          if (response.data.captainConflict) {
            const captainConflict = response.data.captainConflict;
            this.showConflictDialog(captainConflict);
          }
          if (response.data.planBreach) {
            const planBreach = response.data.planBreach;
            this.showConflictDialog(planBreach);
          }
          this.Events.emit(errorEvent, response.data);
        }
      );
    };
    const onRouteUpdate = (options) => {
      const params = {};
      options.methodName =
        options.key === "description" && !options.methodName
          ? "update_description"
          : options.methodName;
      options.value =
        options.key === "price" ? options.value * 100 : options.value;
      params[options.key] = isUndefined(options.value)
        ? options.name
          ? options.name._id
          : null
        : options.value;

      this.Route.updateAction(
        this.$stateParams.id,
        options.methodName,
        params
      ).$promise.then(
        () => {
          this.route[options.key].isDisabled = true;
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("route", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    const onReservationUpdate = (reservation) => {
      const { id, ridePrice, supplyCost } = reservation;
      const errorEvent = this.Events.eventsType.onShowErrorNotification;
      this.Reservation.update(id, {
        ride_price: ridePrice || null,
        supply_cost: supplyCost || null,
      }).$promise.then(
        () => {
          this.Events.emit(showNotificationEvent, {
            message: "Corporate reservation updated successfully",
          });
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.getReservation = (schedule) => {
      if (!isNil(schedule)) {
        // Initialize fields
        schedule.corporate = {
          isDisabled: true,
          name: { name: "N/A" },
        };
        schedule.ride_price = {
          isDisabled: true,
          value: "N/A",
        };
        schedule.supply_cost = {
          isDisabled: true,
          value: "Captain Plan",
        };

        schedule.active_contract = null;
        // Get Reservation by schedule
        this.Reservation.getAll({
          schedule: schedule._id.value,
        }).$promise.then((scheduleReservationResponse) => {
          if (scheduleReservationResponse.hits.length > 0) {
            const corporateReservation =
              scheduleReservationResponse.hits[0]._source;
            schedule.corporate_reservation = corporateReservation._id;
            schedule.corporate = {
              isDisabled: true,
              name: corporateReservation.corporate,
            };
            schedule.ride_price = {
              isDisabled: true,
              value: corporateReservation.ride_price
                ? corporateReservation.ride_price / constants.currencyBy
                : "N/A",
            };
            schedule.supply_cost = {
              isDisabled: true,
              value: corporateReservation.supply_cost
                ? corporateReservation.supply_cost / constants.currencyBy
                : "Captain Plan",
            };
            if (!isNil(corporateReservation.corporate)) {
              this.Contracts.getActive({
                corporateId: corporateReservation.corporate._id,
              }).$promise.then((response) => {
                schedule.active_contract = response;
              });
            }
          }
        });
      }
    };

    // Populate corporate reservations in each schedule
    this.populateReservation = () => {
      // Select business schedules

      this.schedules.forEach((schedule) => {
        if (
          schedule.pricingVersionValue &&
          schedule.pricingVersionValue.value === "fixed"
        ) {
          this.getReservation(schedule);
        }
      });
    };

    const onReflectSchedule = (schedule, faild = []) => {
      const scheduleId = schedule._id.value;
      const route = this.route._id.value;

      const reflect = this.$mdDialog.show({
        controller: dialogCtrl,
        controllerAs: "$ctrl",
        template: dialogTmpl,
        locals: {
          route,
          scheduleId,
          originalSchedule: this.originalSchedule,
          faild,
        },
      });
      reflect.then(
        (selected) => {
          if (this.route.is_dynamic.value) {
            const confirm = this.$mdDialog
              .confirm()
              .title(
                "We will reflect the current captain of the schedule on the selected rides even if they have a backup assigned and no other changes of the schedule will be reflected. Are you sure you want to continue?"
              )
              .ok("Yes")
              .cancel("Cancel");

            this.$mdDialog.show(confirm).then(() => {
              this.$mdDialog.hide();
              const rideIds = map((item) => item._id)(selected);
              this.Schedule.reflect(scheduleId, {
                ride_ids: rideIds,
              }).$promise.then(
                () => {
                  schedule.newCaptain = false;
                  this.Events.emit(showNotificationEvent, {
                    message:
                      "Your schedule changes have been reflected successfully.",
                  });
                },
                (response) => {
                  const faildRides = response.data.failures;

                  this.Events.emit(errorEvent, response.data);
                  onReflectSchedule(schedule, faildRides);
                }
              );
            });
          } else {
            const rideIds = map((item) => item._id)(selected);
            this.Schedule.reflect(scheduleId, {
              ride_ids: rideIds,
            }).$promise.then(
              () => {
                this.Events.emit(showNotificationEvent, {
                  message:
                    "Your schedule changes have been reflected successfully.",
                });
              },
              (response) => {
                const faildRides = response.data.failures;

                this.Events.emit(errorEvent, response.data);
                onReflectSchedule(schedule, faildRides);
              }
            );
          }
        },
        () => {}
      );
    };

    this.filterSchedules = (item, filter) => {
      this.schedulesPage = 1;

      if (item === "Active") {
        this.active = filter;
      }
      if (item === "Label") {
        this.label = filter;
      }
      if (item === "ID") {
        this.scheduledID = filter;
      }
      if (item === "Time") {
        this.time = filter;
      }
      this.Schedule.getAll({
        route: this.$stateParams.id,
        limit: this.schedulesLimit,
        isCityRequired: false,
        label: this.label ? this.label : "",
        active: this.active ? this.active : "",
        schedule_id: this.scheduledID ? this.scheduledID : "",
        time_from: this.time
          ? this.time.from +
            (constants.utcTimeZoneFromMachineTimeZone *
              constants.fromHourToMilli +
              this.routeTimezone)
          : null,
        time_to: this.time
          ? this.time.to +
            (constants.utcTimeZoneFromMachineTimeZone *
              constants.fromHourToMilli +
              this.routeTimezone)
          : null,
        page: 1,
      }).$promise.then((response) => {
        this.schedules = this.RouteTransforms.justifySchedule(
          response.hits,
          this.routeTimezone
        );
        this.schedulesTotal = response.total;
        this.hasPaging = this.schedulesTotal > this.schedules.length;
        this.formatedSchedules = map(formatSchedules)(this.schedules);
      });
    };
    const onDeleteSchedule = (schedule, index) => {
      this.Schedule.delete(schedule._id.value).$promise.then(
        () => {
          this.Events.emit(showNotificationEvent, {
            message: "Your schedule has been deleted successfully.",
          });
          this.schedules.splice(index, 1);
        },
        (response) => {
          this.Events.emit(errorEvent, response.data);
        }
      );
    };

    this.Route.get(this.$stateParams.id).$promise.then((response) => {
      this.originalSchedule = assign({}, response.schedules);
      if (response.polyline) {
        this.decodedPolyline = polyline.decode(response.polyline);
      }
      this.route = this.RouteTransforms.justify(response);
      // Route Time zone
      if (!isNil(this.route.city.timezone)) {
        this.routeTimezone = this.route.city.timezone;
      }
      getAllSchedules();
    });

    this.loadMoreSchedules = () => {
      this.schedulesPage += 1;
      this.Schedule.getAll({
        route: this.$stateParams.id,
        limit: this.schedulesLimit,
        page: this.schedulesPage,
        label: this.label,
        active: this.active,
        schedule_id: this.scheduledID,
        time_from: this.time
          ? this.time.from +
            (constants.utcTimeZoneFromMachineTimeZone *
              constants.fromHourToMilli +
              this.routeTimezone)
          : "",
        time_to: this.time
          ? this.time.to +
            (constants.utcTimeZoneFromMachineTimeZone *
              constants.fromHourToMilli +
              this.routeTimezone)
          : "",
      }).$promise.then((response) => {
        this.schedules = concat(
          this.schedules,
          this.RouteTransforms.justifySchedule(
            response.hits,
            this.routeTimezone
          )
        );
        this.populateReservation();
        this.hasPaging = this.schedulesTotal > this.schedules.length;
        this.formatedSchedules = map(formatSchedules)(this.schedules);
      });
    };

    this.reflectChanges = () => {
      const route = this.route._id.value;
      const reflect = this.$mdDialog.show({
        controller: dialogCtrl,
        controllerAs: "$ctrl",
        template: dialogTmpl,
        locals: {
          route,
          scheduleId: null,
          originalSchedule: this.originalSchedule,
          faild: [],
        },
      });

      reflect.then(
        (selected) => {
          const rideIds = map((item) => item._id)(selected);
          this.Route.reflectDetails(this.$stateParams.id, {
            ride_ids: rideIds,
          }).$promise.then(
            () => {
              this.Events.emit(showNotificationEvent, {
                message: "Your changes have been reflected successfully.",
              });
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.dispatchRoute = () => {
      const dispatch = this.$mdDialog.show({
        controller: dispatchDialogCtrl,
        controllerAs: "$ctrl",
        template: dispatchDialogTmpl,
      });

      dispatch.then(
        (obj) => {
          const date = moment(obj.date).startOf("day").toDate().toISOString();
          this.Route.dispatch(this.$stateParams.id, { date }).$promise.then(
            () => {
              this.Events.emit(showNotificationEvent, {
                message: "Your route has been dispatched successfully.",
              });
            },
            (response) => this.Events.emit(errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.Events.on(this.routeStationEvent, onStationEdit);
    this.Events.on(this.onUpdateRoute, onRouteUpdate);
    this.Events.on(this.onReservationUpdateEvent, onReservationUpdate);
    this.Events.on(this.reflectRouteEvent, onReflectSchedule);
    this.Events.on(this.deleteScheduleEvent, onDeleteSchedule);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/route/route.controller.js